<template>
    <div class="modal fade" id="modal_details_income" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestIncomePayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.income.payment.title') }}

                    </h5>
                    <button @click="closeModal('modal_details_income', 'view')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body">

                    <div class="row mb-3">
                        <div class="col-md-12">
                            <h4 class="title-h4">
                                {{ i18n.t('views.clients.income.payment.info') }}
                            </h4>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-md-6">

                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.income.customer.title') }} </b> :
                                <span v-if="income?.member_info">
                                    {{ i18n.t('tables.income.customer.memberClub') }}
                                </span>
                                <span v-else>
                                    {{ i18n.t('tables.income.customer.foreignMember') }}
                                </span>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.members.name') }} </b> : {{
                                    income?.memberName ?? '' }}

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.income.category_name') }} </b> :
                                <span>{{ income?.service?.category?.name ?? '' }}</span>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.income.service_name') }} </b>:
                                <span>{{ income?.service?.name ?? '' }}</span>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.income.total_amount') }} </b>:
                                {{ income?.total_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160">{{ i18n.t('tables.income.total_amount_paid') }}
                                </b> :
                                {{ income?.total_amount_paid ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div v-if="income?.remaining_amount > 0" class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.income.remaining_amount') }}
                                </b> :
                                {{ income?.remaining_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                            </div>
                            <div v-if="income.remaining_amount <= 0" class="form-group mb-1 mt-1">
                                <p class="timeline-content">
                                    <b class="d-inline-block w-160"> {{
                                        i18n.t('tables.subscription_member.remaining_amount') }} </b>:
                                    <span class="badges badges-bg badges-actif">{{
                                        i18n.t('tables.subscription_member.paid') }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160">{{ i18n.t('tables.income.description') }}
                                </b> :
                                {{ income?.description ?? '' }}
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160">{{ i18n.t('tables.income.date') }}
                                </b> :
                                {{ formatDate(income?.date) }}
                            </div>
                        </div>

                    </div>
                    <div class="row  mb-3">
                        <div class="col-md-12">
                            <h4 class="title-h4">
                                {{ i18n.t('views.clients.income.payment.paid') }}
                            </h4>
                        </div>
                    </div>
                    <div v-if="incomesPaymentsList?.length > 0" class="tab-pane fade in active show" id="members"
                        style="overflow-x: auto;">
                        <table class="datatables table table-striped table-bordered  ">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        {{ i18n.t('tables.payment.paymentDate') }}
                                    </th>

                                    <th>
                                        {{ i18n.t('tables.payment.paymentMethod') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.chequeName') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.bankName') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.chequeNum') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.dueDate') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.amount_paid') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.action') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(transaction, index) in incomesPaymentsList" value="member.id"
                                    v-bind:key="transaction?.id">
                                    <td>
                                        {{ formatDate(transaction?.paymentDate) }}
                                    </td>
                                    <td>
                                        {{ transaction.paymentMethod }}
                                    </td>
                                    <td>
                                        {{ transaction.chequeName }}
                                    </td>

                                    <td>
                                        {{ transaction?.bankName }}
                                    </td>

                                    <td>
                                        {{ transaction?.chequeNum }}
                                    </td>
                                    <td>
                                        {{ formatDate(transaction?.dueDate) }}
                                    </td>
                                    <td>
                                        {{ transaction?.amount_paid ?? 0.00 }} {{ i18n.t('symbole.currency.mad') }}
                                    </td>
                                    <td>
                                        <btn-delete @delete="delet(transaction?.id, transaction?.amount_paid ?? 0)" />
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div v-else>
                        <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, computed, watch, toRefs } from "vue";
/*Components*/


/*plugins*/
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { useIncomePayment } from "@/composables/income/useIncomePayment";
import { incomesPayments } from "@/shared/state";
//import { IncomePayment } from "@/interfaces/income";
import { useGlobal } from "@/composables/global/useGlobal";

export default defineComponent({
    components: {},
    name: "transactions-income",
    props: {
        income: {
            type: Object,
            default: null,
        }
    },
    setup(props) {
        const { income } = toRefs(props);
        const { formatDate } = useGlobal();


        const { closeModal } = useModal();

        const { getPayments, deletePayment, isRequestIncomePayment } = useIncomePayment();

        const incomesPaymentsList = computed(() => incomesPayments.data);
        /**
       * Delete Income by ID
       */
        const delet = (paymentID: number, amount_paid: number) => {
            Swal.fire({
                title: i18n.t("message.confirmation.delete.title"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: i18n.t("button.delete"),
                cancelButtonText: i18n.t("button.cancel"),
                allowOutsideClick: false,   // ✅ disable closing by clicking outside
                  allowEscapeKey: false       // (optional) disable closing with ESC
            }).then(async (result) => {
                if (result.isConfirmed) {
                    deletePayment(paymentID, income.value.id, amount_paid);
                }
            });

        };


        watch(
            () => income.value,
            () => {
                getPayments(income.value.id)

            });


        return {
            incomesPaymentsList,
            formatDate,
            i18n,
            closeModal,
            delet,
            isRequestIncomePayment
        };
    },
});
</script>
